import useAxios from '../useAxios'

type GetTenantIdResponse = {
  tenantId: string
}

const useFetchTenantId = () => {
  const axios = useAxios()
  return async (): Promise<GetTenantIdResponse | undefined> => {
    const { data } = await axios({
      method: 'GET',
      url: '/accessTenantId',
    })

    return data
  }
}

export default useFetchTenantId
